import { Cell } from "./cell.js";

export const screen = {
    lines: [
      Array.from("                                        ", ch => new Cell(ch)),
      Array.from("    **** COMMODORE 64 BASIC V2 ****     ", ch => new Cell(ch)),
      Array.from("                                        ", ch => new Cell(ch)),
      Array.from(" 64K RAM SYSTEM  38911 BASIC BYTES FREE ", ch => new Cell(ch)),
      Array.from("                                        ", ch => new Cell(ch)),
      Array.from("READY.                                  ", ch => new Cell(ch)),
      Array.from("                                        ", ch => new Cell(ch)),
      Array.from("                                        ", ch => new Cell(ch)),
      Array.from("                                        ", ch => new Cell(ch)),
      Array.from("                                        ", ch => new Cell(ch)),
      Array.from("                                        ", ch => new Cell(ch)),
      Array.from("                                        ", ch => new Cell(ch)),
      Array.from("                                        ", ch => new Cell(ch)),
      Array.from("                                        ", ch => new Cell(ch)),
      Array.from("                                        ", ch => new Cell(ch)),
      Array.from("                                        ", ch => new Cell(ch)),
      Array.from("                                        ", ch => new Cell(ch)),
      Array.from("                                        ", ch => new Cell(ch)),
      Array.from("                                        ", ch => new Cell(ch)),
      Array.from("                                        ", ch => new Cell(ch)),
      Array.from("                                        ", ch => new Cell(ch)),
      Array.from("                                        ", ch => new Cell(ch)),
      Array.from("                                        ", ch => new Cell(ch)),
      Array.from("                                        ", ch => new Cell(ch)),
      Array.from("                                        ", ch => new Cell(ch))
    ],
    emptyLine: () => Array.from("                                        ", ch => new Cell(ch)),
    cursorPosition: [6, 0],
    clearScreen: async () => {
      // Make sure the screen is cleared before the promise is resolved.
      // This is important for the blinking cursor.
      return new Promise((resolve) => {
        setTimeout(() => {
          for (let i = 0; i < screen.lines.length; i++) {
            screen.lines[i] = screen.emptyLine();
          }
          // Reset the cursor position.
          screen.cursorPosition = [0, 0];
          
          resolve();
        }, 0);
      });
    }
  };